import React from 'react';
import { useContext } from 'react';
import filterContext from '../../context/filters/filterContext';
import './Filter.css';
import Checkbox from 'antd/es/checkbox';
function Timefilter() {
	const { checked, setchecked, handleCheckboxChange } = useContext(
		filterContext
	);

	function isChecked24() {
		if (checked.timeOpt === 0) {
			setchecked({ ...checked, timeOpt: 1 });
		} else {
			setchecked({ ...checked, timeOpt: 0 });
		}
	}
	function isChecked48() {
		if (checked.timeOpt === 0) {
			setchecked({ ...checked, timeOpt: 2 });
		} else {
			setchecked({ ...checked, timeOpt: 0 });
		}
	}
	function isChecked7() {
		if (checked.timeOpt === 0) {
			setchecked({ ...checked, timeOpt: 7 });
		} else {
			setchecked({ ...checked, timeOpt: 0 });
		}
	}
	function isChecked30() {
		if (checked.timeOpt === 0) {
			setchecked({ ...checked, timeOpt: 30 });
		} else {
			setchecked({ ...checked, timeOpt: 0 });
		}
	}
	return (
		<>
			<div className="filterStyle" style={{ height: '60px', marginRight: '0px' }}>
				<label htmlFor="input-field1" className="labelStyle">
					Less than 24
				</label>
				<Checkbox
					id="input-field1"
					name="1"
					checked={checked.timeOpt === 1 ? true : false}
					disabled={checked.timeOpt !== 0 && checked.timeOpt !== 1 ? true : false}
					className="rounded-checkbox"
					type="checkbox"
					value="1"
					onClick={isChecked24}
				/>
			</div>
			<hr />
			<div className="filterStyle" style={{ height: '60px', marginRight: '0px' }}>
				<label htmlFor="input-field2" className="labelStyle">
					Less than 48
				</label>
				<Checkbox
					id="input-field2"
					name="2"
					checked={checked.timeOpt === 2 ? true : false}
					disabled={checked.timeOpt !== 0 && checked.timeOpt !== 2 ? true : false}
					className="rounded-checkbox"
					type="checkbox"
					value="2"
					onClick={isChecked48}
				/>
			</div>
			<hr />
			<div className="filterStyle" style={{ height: '60px', marginRight: '0px' }}>
				<label htmlFor="input-field3" className="labelStyle">
					1 week
				</label>
				<Checkbox
					className="rounded-checkbox"
					name="7"
					checked={checked.timeOpt === 7 ? true : false}
					disabled={checked.timeOpt !== 0 && checked.timeOpt !== 7 ? true : false}
					id="input-field3"
					type="checkbox"
					value="7"
					onClick={isChecked7}
				/>
			</div>
			<hr />
			<div className="filterStyle" style={{ height: '60px', marginRight: '0px' }}>
				<label htmlFor="input-field4" className="labelStyle">
					1 month
				</label>
				<Checkbox
					id="input-field4"
					name="30"
					checked={checked.timeOpt === 30 ? true : false}
					disabled={checked.timeOpt !== 0 && checked.timeOpt !== 30 ? true : false}
					className="rounded-checkbox"
					value="30"
					type="checkbox"
					onClick={isChecked30}
				/>
			</div>
			<hr />
		</>
	);
}

export default Timefilter;
